import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    LOGO_CONTAINER_HEIGHT: 120,
    MODAL_WIDTH: 400,
    MODAL_HEIGHT: 312
};
export default {
    SidebarMenuContainer: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["width", "bgColorDefault"], prop)
    }) `
    width: ${({ width }) => (width ? `${width}px` : "auto")};
    height: 100%;
    background-color: ${({ theme, bgColorDefault }) => theme[bgColorDefault]};
    display: grid;
    grid-template-rows: auto 1fr;
    border-right: 1px solid #dfe5ec;
  `
};
